function typeformUrl(template) {
    return `https://socialnative.typeform.com/to/${template}`;
}

const typeformTemplates = {
    denialSurvey: typeformUrl('beOYLO'),
    optOutSurvey: typeformUrl('Mh0isX')
};

export default typeformTemplates;



// WEBPACK FOOTER //
// ./creator/common/typeform_templates.js